import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { copyToClipboard } from 'utils/copyToClipboard';

import { showMessageAction } from 'store/global/actions';

import { COPY_NOTIFICATION_DURATION } from '../EntityAuditHistory.constants';

/** `(text, message) => Promise`: copies `text` and, once it is on the clipboard, shows a short toast. */
const useCopyWithNotice = () => {
  const dispatch = useDispatch();

  return useCallback(
    (text, message) =>
      copyToClipboard(text).then(
        copied =>
          copied &&
          dispatch(
            showMessageAction({
              withCloseButton: false,
              message,
              variant: 'success',
              duration: COPY_NOTIFICATION_DURATION,
            }),
          ),
      ),
    [dispatch],
  );
};

export default useCopyWithNotice;
